export default __webpack_public_path__ + "static/media/codeblack_mobile.18075b3b.png";